<div class="popup" (click)="$event.stopPropagation()">
  <div class="arrow" [class.top]="below" [style.left]="'calc(50% - ' + arrowShift + 'px)'"></div>
  <button type="button" class="close" (click)="closed.emit()" aria-label="Close">×</button>
  <div class="name">{{ detail?.name || place.name }}</div>
  <div class="sub">{{ kindLabel(place.kind) }}<span *ngIf="addressLine"> · {{ addressLine }}</span></div>

  <div class="google">
    <ng-container *ngIf="google === undefined"><span class="muted">Google rating…</span></ng-container>
    <ng-container *ngIf="googleFacts as g">
      <ng-container *ngIf="g.rating !== null; else noRating">
        <span class="stars" [title]="g.rating + ' out of 5'">{{ stars(g.rating) }}</span>
        <strong>{{ g.rating | number: '1.1-1' }}</strong>
        <span class="muted">({{ g.total | number }} review{{ g.total === 1 ? '' : 's' }}) on Google</span>
      </ng-container>
      <ng-template #noRating><span class="muted">No Google rating yet</span></ng-template>
      <a *ngIf="g.url" [href]="g.url" target="_blank" rel="noopener noreferrer" class="ml-1">Open</a>
    </ng-container>
    <span *ngIf="google === null" class="muted">Not found on Google</span>
    <span *ngIf="google === 'unavailable'" class="muted">Google rating unavailable here</span>
  </div>
  <div *ngIf="googleClosed" class="warn">{{ googleClosed }}</div>

  <div *ngIf="detail as d" class="facts">
    <a *ngIf="d.website" [href]="d.website" target="_blank" rel="noopener noreferrer nofollow">{{ d.website.replace('https://', '').replace('http://', '').replace('www.', '') }}</a>
    <a *ngIf="d.phone" [href]="'tel:' + d.phone">{{ d.phone }}</a>
  </div>

  <div class="badges">
    <span *ngIf="detail?.provider" class="badge b-conductor">In Conductor{{ detail?.status === 'retired' ? ' · not for new bookings' : '' }}</span>
    <span *ngIf="detail?.listing === 'listed'" class="badge b-website">On the website</span>
    <span *ngIf="detail?.listing === 'pending'" class="badge b-pending">{{ detail?.request?.source === 'ai' ? 'AI suggested · waiting for review' : 'Waiting for review' }}</span>
    <span *ngIf="detail?.status === 'hidden'" class="badge">Hidden in curation</span>
  </div>

  <div *ngIf="error" class="err">{{ error }}</div>
  <div *ngIf="message" class="ok">{{ message }}</div>

  <ng-container *ngIf="detail as d">
    <!-- Possible duplicates found by the dedupe gate: dismiss each, or open it. -->
    <div *ngIf="matches?.length && !d.provider" class="matches">
      <div class="muted">It may already be in Conductor as:</div>
      <div *ngFor="let m of matches" class="match">
        <span>{{ m.name }} <span class="muted">({{ m.why.join(', ') }})</span></span>
        <span *ngIf="m.hard" class="warn">already linked</span>
        <a *ngIf="!m.hard" class="link" (click)="toggleDismiss(m)">{{ dismissed.has(m.serviceId) ? 'Not this one ✓' : 'Not this one' }}</a>
        <a *ngIf="canOpenProviders" class="link" [href]="'#/dashboard/service-providers/locations?serviceId=' + m.serviceId" target="_blank" rel="noopener">Open</a>
      </div>
    </div>

    <div *ngIf="!readOnly" class="actions">
      <ng-container *ngIf="d.listing !== 'listed'">
        <button *ngIf="d.listable && d.status !== 'hidden'" pButton type="button" class="p-button-sm p-button-success popup-website" icon="pi pi-globe" label="Add to website" (click)="addToWebsite()" [disabled]="busy"></button>
      </ng-container>
      <button *ngIf="d.listing === 'listed'" pButton type="button" class="p-button-sm p-button-text p-button-danger" label="Remove from website" (click)="removeFromWebsite()" [disabled]="busy"></button>

      <ng-container *ngIf="d.provider && canManageConductor">
        <button *ngIf="d.status === 'retired'" pButton type="button" class="p-button-sm p-button-text" label="Use for new bookings again" (click)="conductorOut('unretire')" [disabled]="busy"></button>
        <button *ngIf="d.status !== 'retired' && !d.providerRefs" pButton type="button" class="p-button-sm p-button-text p-button-danger popup-remove-conductor" label="Remove from Conductor" (click)="conductorOut('remove')" [disabled]="busy"></button>
        <button *ngIf="d.status !== 'retired' && d.providerRefs" pButton type="button" class="p-button-sm p-button-text p-button-danger" label="Stop using for new bookings" (click)="conductorOut('retire')" [disabled]="busy"
                [pTooltip]="'On ' + d.providerRefs + ' arrangement' + (d.providerRefs === 1 ? '' : 's') + ', so it can\'t be removed'"></button>
      </ng-container>
      <button *ngIf="!d.provider && d.removedProvider && canManageConductor" pButton type="button" class="p-button-sm popup-restore" icon="pi pi-replay" label="Restore to Conductor" (click)="restore()" [disabled]="busy"
              [pTooltip]="'Brings back ' + (d.removedProvider.name || 'the provider') + ', removed from Conductor earlier'"></button>
      <span *ngIf="!d.provider && !d.removedProvider" class="add-conductor">
        <button pButton type="button" class="p-button-sm popup-conductor" icon="pi pi-plus" [label]="(matches?.length ? 'Add anyway as ' : 'Add to Conductor as ') + blockLabel[blockType]"
                (click)="addToConductor()" [disabled]="busy || (!!matches?.length && !canAddAnyway)"></button>
        <select class="as" [(ngModel)]="blockType" [disabled]="busy" aria-label="Add as" title="Add as">
          <option *ngFor="let o of blockOptions" [ngValue]="o.value">{{ o.label }}</option>
        </select>
      </span>
    </div>
    <div *ngIf="!d.listable && d.listing !== 'listed'" class="muted small">Suburb pages don't list this kind of place.</div>
  </ng-container>

  <a class="link details" (click)="details.emit(place.locationId)">Details, rename, notes →</a>
</div>
